<template>
  <div id="longhuluzhu">
    <div class="tr-header">
      <p class="title">龙虎路珠</p>
      <div class="dayHandles">
        <DatePick @onchange="onchangeDate"></DatePick>
      </div>
    </div>
    <div class="tr-header-container">
      <div class="handle-con">
        <div class="title">
          <span>筛选号码</span>
          <div class="handles" style="display:inline-block;padding-left:20px">
            <CheckboxGroup v-model="selectBalls">
              <Checkbox
                v-if="betType == 'hpten'"
                :label="it.key"
                v-for="(it,i) in balls"
                :key="i"
              >第{{i + 1}}球</Checkbox>
            </CheckboxGroup>
          </div>
          <span class="select_span" @click="allSelect">全选</span>
          <span class="select_span" @click="selectBalls = []">清空</span>
        </div>
      </div>
    </div>

    <div class="tr-table-container" v-if="dataSource.length>0">
      <Road
        v-for="(it,i) in dataSource"
        :data="it"
        v-if="~selectBalls.indexOf(Object.keys(it)[0])"
        :betType="betType"
        :key="i"
        :date="selectDay"
      ></Road>
    </div>
  </div>
</template>

<script>
import DatePick from "../components/DatePick";
import dayjs from "dayjs";
import statistic from "../../../helpers/statistic";
import Road from "./Road";
import format from "../../../helpers/format.js";

function setBall(start, len) {
  let res = [];
  for (let i = start; i <= len; i++) {
    res.push({
      name: `第${i}球`,
      key: `lhDewdrop${i}`
    });
  }
  return res;
}
export default {
  name: "longhuluzhu",
  components: {
    DatePick,
    Road
  },
  data() {
    return {
      selectDay: dayjs(new Date()).format("YYYY-MM-DD"),
      dataSource: [],
      balls: [],
      selectBalls: []
    };
  },
  computed: {
    betType() {
      return this.$route.params.betType;
    },
    roadsData() {
      return statistic.getBallRoads(this.betType, this.dataSource);
    }
  },
  created() {
    this.reset();
  },
  watch: {
    selectBalls() {
      // console.log("ball", this.selectBalls);
    }
  },
  methods: {
    allSelect() {
      this.selectBalls = this.balls.map(x => x.key);
    },
    onchangeDate(date) {
      this.selectDay = dayjs(date).format("YYYY-MM-DD");
      this.getData();
    },
    reset() {
      if (this.betType == "hpten") {
        this.balls = setBall(1, 4);
        this.selectBalls = this.balls.map(x => x.key);
      }
    },
    init() {
      this.getData();
    },
    async getData() {
      let res = await this.$http.post("/queryKcDateReport.do", {
        gameType: this.$route.params.gameType,
        date: this.selectDay
      });
      if (res.data.returnCode == "0000") {
        let arr = format.formatJson(res.data.returnList);
        if (arr.length > 0) {
          let a = this.formatList(arr[0].ball_dewdrop_json);
          this.dataSource = a;
        }
      } else {
        this.$Message.error(res.data.returnMessage);
      }
    },
    //截取龙珠数据
    formatList(val) {
      const arr = [];
      const keys = ["lhDewdrop1", "lhDewdrop2", "lhDewdrop3", "lhDewdrop4"];
      for (let key of keys) {
        let o = Object.create(null);
        o[key] = val[key];
        arr.push(o);
      }
      return arr;
    }
  }
};
</script>

<style lang="less" scoped>
@import url("./index.less");
</style>




// WEBPACK FOOTER //
// src/pages/Trend/Longhuluzhu/index.vue